import { Link } from 'react-router-dom';
import { FaInstagram, FaLinkedinIn, FaFacebookF } from 'react-icons/fa'; // Social media icons
import { FaXTwitter } from "react-icons/fa6";
import './Footer.css';
import withCssScope from '../withCssScope';

const Footer = () => {
  return (
    <footer className="bg-dark text-white"  style={{ padding: "50px" }}>
      <div className="container">
        <div className="row">
          {/* Quick Links */}
          <div className="col-md-4 mb-4">
            <h5 className="mb-3">Quick Links</h5>
            <ul className="list-unstyled">
              <li>
                <Link to="/support" className="text-white text-decoration-none">Support</Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-white text-decoration-none">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms-and-conditions" className="text-white text-decoration-none">Terms and Conditions</Link>
              </li>
              <li>
                <Link to="/delete-account" className="text-white text-decoration-none">Delete Account</Link>
              </li>
            </ul>
          </div>

          {/* Social Media Links */}
          <div className="col-md-4 mb-4">
            <h5 className="mb-3">Follow Us</h5>
            <div className="d-flex gap-3 social-icons">
              <a
                href="https://www.facebook.com/profile.php?id=61573526260313"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white text-decoration-none"
              >
                <FaFacebookF size={21} />
              </a>
              <a
                href="https://x.com/Prorenter182683"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white text-decoration-none"
              >
                <FaXTwitter size={21} />
              </a>
              <a
                href="https://www.linkedin.com/company/106638928"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white text-decoration-none"
              >
                <FaLinkedinIn size={24} />
              </a>
              <a
                href="https://www.instagram.com/prorenter.app?igsh=MTNjcTU3NGpobXU1eg=="
                target="_blank"
                rel="noopener noreferrer"
                className="text-white text-decoration-none"
              >
                <FaInstagram size={24} />
              </a>
            </div>
          </div>

          {/* Contact Information */}
          <div className="col-md-4 mb-4">
            <h5 className="mb-3">Contact Us</h5>
            <ul className="list-unstyled">
              <li className="text-white"><a
                  href="mailto:support@pro-renter.com"
                  className="text-decoration-none d-flex align-items-center"
                > Email: support@pro-renter.com</a>
              </li>
              <li className="text-white">Address: Dubai, United Arab Emirates</li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="text-center mt-4 pt-3 border-top">
          <p className="mb-0">&copy; 2025 Prorenter. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default withCssScope(Footer, 'scope-footer');